import React from 'react';
import moment from 'moment';
import { IMessage } from '@eagerdog/interfaces';
import styles from './Messages.module.scss';

interface IProps {
  message: IMessage;
  currentUserId: string;
}

const MessageBubble: React.FC<IProps> = ({ message, currentUserId }) => {
  const isSent = message.sender_id === currentUserId;

  return (
    <div className={`${styles.messageBubble} ${isSent ? styles.sent : styles.received}`}>
      <div className={styles.bubble}>{message.content}</div>
      <div className={styles.bubbleTime}>
        {moment(message.created_at).format('h:mm A')}
      </div>
    </div>
  );
};

export default MessageBubble;
